export const AffiliateCodeType = {
  Link: 'Link',
  Coupon: 'Coupon',
} as const

export type AffiliateCodeType =
  (typeof AffiliateCodeType)[keyof typeof AffiliateCodeType]

export const AffiliateCustomerSourceType = {
  Coupon: 'Coupon',
  Link: 'Link',
  Manual: 'Manual',
} as const

export type AffiliateCustomerSourceType =
  (typeof AffiliateCustomerSourceType)[keyof typeof AffiliateCustomerSourceType]

/**
 * How far a referred person has come, in the funnel's own order: they signed
 * up, they created an account, they are paying. The API tags every row of the
 * customers list with one of these.
 */
export const AffiliateCustomerStage = {
  Registered: 'Registered',
  AccountCreated: 'AccountCreated',
  Subscribed: 'Subscribed',
} as const

export type AffiliateCustomerStage =
  (typeof AffiliateCustomerStage)[keyof typeof AffiliateCustomerStage]

export const AffiliateCustomerTimelineEventType = {
  UserRegistered: 'UserRegistered',
  AccountCreated: 'AccountCreated',
  AttributionBound: 'AttributionBound',
  AttributionSuperseded: 'AttributionSuperseded',
  InvoicePaid: 'InvoicePaid',
} as const

export type AffiliateCustomerTimelineEventType =
  (typeof AffiliateCustomerTimelineEventType)[keyof typeof AffiliateCustomerTimelineEventType]

export const AffiliateCommissionStatus = {
  Pending: 'Pending',
  Released: 'Released',
  Cancelled: 'Cancelled',
} as const

export type AffiliateCommissionStatus =
  (typeof AffiliateCommissionStatus)[keyof typeof AffiliateCommissionStatus]

export const AffiliateWithdrawalStatus = {
  Requested: 'Requested',
  Paid: 'Paid',
  Rejected: 'Rejected',
} as const

export type AffiliateWithdrawalStatus =
  (typeof AffiliateWithdrawalStatus)[keyof typeof AffiliateWithdrawalStatus]

/**
 * Declared in the order the selects offer them, which is not the order the
 * backend numbers them (`AffiliatePayoutMethodType.cs`): the wire value is the
 * name, so the order here is presentation only. `Other` stays last — it is the
 * fallback, not a peer of the three named rails.
 */
export const AffiliatePayoutMethodType = {
  PayPal: 'PayPal',
  Pix: 'Pix',
  BankTransfer: 'BankTransfer',
  Other: 'Other',
} as const

export type AffiliatePayoutMethodType =
  (typeof AffiliatePayoutMethodType)[keyof typeof AffiliatePayoutMethodType]
